import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loadable from '@/components/common/loadable';
import { requestProductDetail } from '@/store/actions/product';
import Loading from '@/components/common/loading';

const ProductInfo = Loadable({
  loader: () => import('@/components/product/product-info'),
});

export default function ProductInformation({ match: { params } }) {
  const dispatch = useDispatch();
  const isLoading = useSelector(({ product }) => product.isLoading);
  useEffect(() => {
    dispatch(requestProductDetail({ ...params }));
  }, []);

  if (isLoading) return <Loading isLoading />;
  return <ProductInfo />;
}
